{
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "왼쪽 창에서 대화를 선택하십시오.",
    "CSAT_REPLY_MESSAGE": "대화를 평가해 주십시오",
    "404": "죄송합니다. 대화를 찾을 수 없습니다. 다시 시도해 주십시오.",
    "SWITCH_VIEW_LAYOUT": "레이아웃 전환",
    "DASHBOARD_APP_TAB_MESSAGES": "메시지",
    "UNVERIFIED_SESSION": "이 사용자의 신원이 확인되지 않았습니다",
    "NO_MESSAGE_1": "어라! 받은 메시지함에 고객의 메시지가 없는 것 같습니다.",
    "NO_MESSAGE_2": " 페이지에 메시지를 보내기 위해서!",
    "NO_INBOX_1": "안녕하세요! 아직 받은 메시지함을 하나도 추가하지 않은 것 같습니다.",
    "NO_INBOX_2": " 시작하려면",
    "NO_INBOX_AGENT": "어떤 받은 메시지함에도 속하지 않는 것 같습니다. 관리자에게 문의하십시오.",
    "SEARCH_MESSAGES": "대화에서 메시지 검색",
    "VIEW_ORIGINAL": "원본 보기",
    "VIEW_TRANSLATED": "번역 보기",
    "EMPTY_STATE": {
      "CMD_BAR": "명령 메뉴를 열려면",
      "KEYBOARD_SHORTCUTS": "키보드 단축키를 보려면"
    },
    "SEARCH": {
      "TITLE": "메시지 검색",
      "RESULT_TITLE": "검색 결과",
      "LOADING_MESSAGE": "데이터 처리 중...",
      "PLACEHOLDER": "검색할 텍스트를 입력하십시오",
      "NO_MATCHING_RESULTS": "검색 결과가 없습니다."
    },
    "UNREAD_MESSAGES": "안 읽은 메시지",
    "UNREAD_MESSAGE": "안 읽은 메시지",
    "CLICK_HERE": "여기를 클릭하십시오",
    "LOADING_INBOXES": "받은 메시지함 불러오는 중",
    "LOADING_CONVERSATIONS": "대화 불러오는 중",
    "CANNOT_REPLY": "다음 사유로 답장할 수 없습니다",
    "24_HOURS_WINDOW": "24시간 메시지 창 제한",
    "48_HOURS_WINDOW": "48시간 메시지 창 제한",
    "API_HOURS_WINDOW": "이 대화에는 {hours}시간 이내에만 답장할 수 있습니다",
    "NOT_ASSIGNED_TO_YOU": "이 대화는 귀하에게 배정되지 않았습니다. 이 대화를 자신에게 배정하시겠습니까?",
    "ASSIGN_TO_ME": "나에게 배정",
    "BOT_HANDOFF_MESSAGE": "현재 어시스턴트 또는 봇이 처리 중인 대화에 응답하고 있습니다.",
    "BOT_HANDOFF_ACTION": "열림으로 표시하고 나에게 배정",
    "BOT_HANDOFF_REOPEN_ACTION": "대화를 열림으로 표시",
    "BOT_HANDOFF_SUCCESS": "대화가 귀하에게 인계되었습니다",
    "BOT_HANDOFF_ERROR": "대화 인계에 실패했습니다. 다시 시도해 주십시오.",
    "TWILIO_WHATSAPP_CAN_REPLY": "다음 사유로 인해 템플릿 메시지로만 이 대화에 답장할 수 있습니다",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24시간 메시지 창 제한",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "이 Instagram 계정은 새 Instagram 채널 받은 메시지함으로 마이그레이션되었습니다. 모든 새 메시지는 해당 받은 메시지함에 표시됩니다. 이 대화에서는 더 이상 메시지를 보낼 수 없습니다.",
    "INSTAGRAM_RESTRICTION_BANNER": "Instagram is currently restricted. Some messages or actions may be delayed or unavailable while we restore full support.",
    "INSTAGRAM_RESTRICTION_STATUS_LINK": "View status update",
    "REPLYING_TO": "회신할 대상:",
    "REMOVE_SELECTION": "선택 항목 제거",
    "DOWNLOAD": "다운로드",
    "UNKNOWN_FILE_TYPE": "알 수 없는 파일",
    "SAVE_CONTACT": "연락처 저장",
    "NO_CONTENT": "표시할 내용이 없습니다",
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender}님이 연락처를 공유했습니다",
      "LOCATION": "{sender}님이 위치를 공유했습니다",
      "FILE": "{sender}님이 파일을 공유했습니다",
      "MEETING": "{sender}님이 회의를 시작했습니다"
    },
    "UPLOADING_ATTACHMENTS": "첨부 파일 업로드 중...",
    "REPLIED_TO_STORY": "스토리에 답장했습니다",
    "UNSUPPORTED_MESSAGE": "이 메시지는 지원되지 않습니다. 확인하려면 원래 플랫폼에서 열어 주십시오.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "이 메시지는 지원되지 않습니다. Facebook Messenger 앱에서 이 메시지를 확인할 수 있습니다.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "이 메시지는 지원되지 않습니다. Instagram 앱에서 이 메시지를 확인할 수 있습니다.",
    "UNSUPPORTED_MESSAGE_TIKTOK": "이 메시지는 지원되지 않습니다. TikTok 앱에서 이 메시지를 확인할 수 있습니다.",
    "UNSUPPORTED_MESSAGE_WHATSAPP": "This message is unsupported. You can view this message on the WhatsApp app.",
    "SUCCESS_DELETE_MESSAGE": "메시지가 성공적으로 삭제되었습니다",
    "FAIL_DELETE_MESSSAGE": "메시지를 삭제할 수 없습니다! 다시 시도해 주십시오.",
    "NO_RESPONSE": "응답 없음",
    "RESPONSE": "응답",
    "RATING_TITLE": "평점",
    "FEEDBACK_TITLE": "피드백",
    "REPLY_MESSAGE_NOT_FOUND": "메시지를 사용할 수 없습니다",
    "CARD": {
      "SHOW_LABELS": "라벨 표시",
      "HIDE_LABELS": "라벨 숨기기",
      "LABELS_COUNT": "{count} labels"
    },
    "VOICE_CALL": {
      "INCOMING_CALL": "수신 전화",
      "OUTGOING_CALL": "발신 전화",
      "CALL_IN_PROGRESS": "통화 중",
      "NO_ANSWER": "응답 없음",
      "NO_ANSWER_OUTBOUND_LABEL": "응답 없음",
      "NO_ANSWER_OUTBOUND_SUBTEXT": "Contact didn't pick up",
      "MISSED_CALL": "부재중 전화",
      "MISSED_CALL_INBOUND_SUBTEXT": "No agent picked up",
      "MISSED_CALL_DECLINED_BY": "Declined by {agentName}",
      "CALL_ENDED": "통화 종료",
      "HANDLED_BY": "Handled by {agentName}",
      "NOT_ANSWERED_YET": "아직 응답하지 않았습니다",
      "CALLING": "Calling…",
      "THEY_ANSWERED": "상대방이 응답했습니다",
      "YOU_ANSWERED": "귀하가 응답했습니다",
      "AGENT_ANSWERED": "{agentName} answered",
      "JOIN_CALL": "통화 참가",
      "CALL_BACK": "Call back",
      "TRANSCRIPT_SHOW_MORE": "Show more",
      "TRANSCRIPT_SHOW_LESS": "Show less"
    },
    "HEADER": {
      "RESOLVE_ACTION": "해결함",
      "REOPEN_ACTION": "다시 열기",
      "OPEN_ACTION": "열기",
      "MORE_ACTIONS": "추가 작업",
      "OPEN": "더보기",
      "CLOSE": "닫기",
      "DETAILS": "자세히",
      "COPY_ID_SUCCESS": "Conversation ID copied to clipboard",
      "SNOOZED_UNTIL": "다음까지 일시 중지",
      "SNOOZED_UNTIL_TOMORROW": "내일까지 일시 중지",
      "SNOOZED_UNTIL_NEXT_WEEK": "다음 주까지 일시 중지",
      "SNOOZED_UNTIL_NEXT_REPLY": "다음 답장까지 일시 중지",
      "WHATSAPP_CALL": "Start WhatsApp call",
      "WHATSAPP_CALL_FAILED": "Could not start the WhatsApp call.",
      "VOICE_CALL": "Start call",
      "VOICE_CALL_FAILED": "Could not start the call.",
      "WHATSAPP_CALL_PERMISSION_REQUESTED": "Sent a call permission request to the contact. Try again once they accept.",
      "WHATSAPP_CALL_PERMISSION_PENDING": "Call permission request already sent recently. Try again once the contact accepts.",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "초과",
        "DUE": "마감 예정"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "보류로 표시",
      "SNOOZE_UNTIL": "일시 중지",
      "SNOOZE": {
        "TITLE": "다음까지 일시 중지",
        "NEXT_REPLY": "다음 답장",
        "TOMORROW": "내일",
        "NEXT_WEEK": "다음 주"
      }
    },
    "MENTION": {
      "AGENTS": "에이전트",
      "TEAMS": "팀"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "다음까지 일시 중지",
      "APPLY": "일시 중지",
      "CANCEL": "취소"
    },
    "PRIORITY": {
      "TITLE": "우선순위",
      "OPTIONS": {
        "NONE": "없음",
        "URGENT": "긴급",
        "HIGH": "높음",
        "MEDIUM": "중간",
        "LOW": "낮음"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "없음",
        "INPUT_PLACEHOLDER": "우선순위 선택",
        "NO_RESULTS": "검색 결과가 없습니다",
        "SUCCESSFUL": "대화 ID {conversationId}의 우선순위가 {priority}(으)로 변경되었습니다",
        "FAILED": "우선순위를 변경할 수 없습니다. 다시 시도해 주십시오."
      }
    },
    "DELETE_CONVERSATION": {
      "TITLE": "대화 #{conversationId} 삭제",
      "DESCRIPTION": "이 대화를 삭제하시겠습니까?",
      "CONFIRM": "삭제"
    },
    "CARD_CONTEXT_MENU": {
      "PENDING": "보류로 표시",
      "RESOLVED": "해결됨으로 표시",
      "MARK_AS_UNREAD": "읽지 않음으로 표시",
      "MARK_AS_READ": "읽음으로 표시",
      "REOPEN": "대화 다시 열기",
      "SNOOZE": {
        "TITLE": "일시 중지",
        "NEXT_REPLY": "다음 답장까지",
        "TOMORROW": "내일까지",
        "NEXT_WEEK": "다음 주까지"
      },
      "ASSIGN_AGENT": "에이전트 배정",
      "ASSIGN_LABEL": "라벨 배정",
      "AGENTS_LOADING": "에이전트 불러오는 중...",
      "ASSIGN_TEAM": "팀 배정",
      "DELETE": "대화 삭제",
      "OPEN_IN_NEW_TAB": "새 탭에서 열기",
      "COPY_LINK": "대화 링크 복사",
      "COPY_LINK_SUCCESS": "대화 링크가 클립보드에 복사되었습니다",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "대화 ID {conversationId}이(가) \"{agentName}\"에게 배정되었습니다",
          "FAILED": "에이전트를 배정할 수 없습니다. 다시 시도해 주십시오."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "라벨 #{labelName}이(가) 대화 ID {conversationId}에 배정되었습니다",
          "FAILED": "라벨을 배정할 수 없습니다. 다시 시도해 주십시오."
        },
        "LABEL_REMOVAL": {
          "SUCCESFUL": "라벨 #{labelName}이(가) 대화 ID {conversationId}에서 제거되었습니다",
          "FAILED": "라벨을 제거할 수 없습니다. 다시 시도해 주십시오."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "팀 \"{team}\"이(가) 대화 ID {conversationId}에 배정되었습니다",
          "FAILED": "팀을 배정할 수 없습니다. 다시 시도해 주십시오."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "메시지 서명",
      "ENABLE_SIGN_TOOLTIP": "서명 활성화",
      "DISABLE_SIGN_TOOLTIP": "서명 비활성화",
      "MSG_INPUT": "줄바꿈을 하시려면 Shift + Enter를 누르십시오. '/'로 시작하여 미리 준비된 답변을 사용할 수 있습니다.",
      "PRIVATE_MSG_INPUT": "줄바꿈을 하시려면 Shift + Enter를 누르십시오. 에이전트만 볼 수 있습니다.",
      "MESSAGING_RESTRICTED": "이 대화에 답장할 수 없습니다",
      "MESSAGING_RESTRICTED_WHATSAPP": "24시간 메시지 창 제한으로 인해 템플릿 메시지로만 답장할 수 있습니다",
      "MESSAGING_RESTRICTED_API": "메시지 창 제한으로 인해 템플릿 메시지로만 답장할 수 있습니다",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "메시지 서명이 설정되지 않았습니다. 프로필 설정에서 설정해 주십시오.",
      "COPILOT_MSG_INPUT": "Copilot에 추가 프롬프트를 입력하거나 다른 질문을 하십시오... Enter를 눌러 후속 메시지를 보내십시오",
      "CLICK_HERE": "업데이트하려면 여기를 클릭하십시오",
      "WHATSAPP_TEMPLATES": "WhatsApp 템플릿"
    },
    "REPLYBOX": {
      "REPLY": "답글",
      "PRIVATE_NOTE": "개인 노트",
      "SEND": "보내기",
      "CREATE": "노트 추가",
      "INSERT_READ_MORE": "더 읽기",
      "DISMISS_REPLY": "답글 취소",
      "REPLYING_TO": "답글 대상:",
      "TIP_EMOJI_ICON": "이모티콘 보기",
      "TIP_ATTACH_ICON": "파일 첨부",
      "TIP_AUDIORECORDER_ICON": "오디오 녹음",
      "TIP_AUDIORECORDER_PERMISSION": "오디오 접근 허용",
      "TIP_AUDIORECORDER_ERROR": "오디오를 열 수 없습니다",
      "AUDIO_CONVERSION_FAILED": "Audio conversion failed. Please try again.",
      "DRAG_DROP": "여기에 드래그 앤 드롭하여 첨부하십시오",
      "IMAGE_UPLOAD_SUCCESS": "이미지가 성공적으로 업로드되었습니다",
      "START_AUDIO_RECORDING": "오디오 녹음 시작",
      "STOP_AUDIO_RECORDING": "오디오 녹음 중지",
      "COPILOT_THINKING": "Copilot이 생각하고 있습니다",
      "EMAIL_HEAD": {
        "TO": "받는 사람",
        "ADD_BCC": "숨은 참조 추가",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "이메일 주소를 쉼표로 구분하여 입력하십시오",
          "ERROR": "올바른 이메일 주소를 입력하십시오"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "이메일 주소를 쉼표로 구분하여 입력하십시오",
          "ERROR": "올바른 이메일 주소를 입력하십시오"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "정의되지 않은 변수",
        "MESSAGE": "메시지에 정의되지 않은 변수가 {undefinedVariablesCount}개 있습니다: {undefinedVariables}. 그래도 메시지를 보내시겠습니까?",
        "CONFIRM": {
          "YES": "보내기",
          "CANCEL": "취소"
        }
      },
      "QUOTED_REPLY": {
        "ENABLE_TOOLTIP": "인용된 이메일 스레드 포함",
        "DISABLE_TOOLTIP": "인용된 이메일 스레드 포함하지 않음",
        "REMOVE_PREVIEW": "인용된 이메일 스레드 제거",
        "COLLAPSE": "미리보기 축소",
        "EXPAND": "미리보기 확장"
      }
    },
    "VISIBLE_TO_AGENTS": "개인 노트: 귀하와 귀하의 팀만 볼 수 있습니다",
    "CHANGE_STATUS": "대화 상태가 변경되었습니다",
    "CHANGE_STATUS_FAILED": "대화 상태 변경에 실패했습니다",
    "CHANGE_AGENT": "대화 담당자가 변경되었습니다",
    "CHANGE_AGENT_FAILED": "담당자 변경에 실패했습니다",
    "ASSIGN_LABEL_SUCCESFUL": "라벨이 성공적으로 배정되었습니다",
    "ASSIGN_LABEL_FAILED": "라벨 배정에 실패했습니다",
    "CHANGE_TEAM": "대화 팀이 변경되었습니다",
    "SUCCESS_DELETE_CONVERSATION": "대화가 성공적으로 삭제되었습니다",
    "FAIL_DELETE_CONVERSATION": "대화를 삭제할 수 없습니다! 다시 시도해 주십시오.",
    "FILE_SIZE_LIMIT": "파일이 {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB 첨부 제한을 초과합니다",
    "FILE_TYPE_NOT_SUPPORTED": "이 대화에서 {fileName} 파일 형식은 지원되지 않습니다",
    "MESSAGE_ERROR": "메시지를 보낼 수 없습니다. 나중에 다시 시도해 주십시오.",
    "SENT_BY": "보낸 사람:",
    "BOT": "봇",
    "NATIVE_APP": "네이티브 앱",
    "NATIVE_APP_ADVISORY": "이 메시지는 네이티브 앱에서 전송되었습니다. 메시지 창을 유지하려면 Chatwoot에서 답장하십시오.",
    "SEND_FAILED": "메시지를 보낼 수 없습니다! 다시 시도해 주십시오.",
    "TRY_AGAIN": "재시도",
    "ASSIGNMENT": {
      "SELECT_AGENT": "에이전트 선택",
      "REMOVE": "제거",
      "ASSIGN": "배정"
    },
    "CONTEXT_MENU": {
      "COPY": "복사",
      "REPLY_TO": "이 메시지에 답장",
      "DELETE": "삭제",
      "CREATE_A_CANNED_RESPONSE": "미리 준비된 답변에 추가",
      "TRANSLATE": "번역",
      "COPY_PERMALINK": "메시지 링크 복사",
      "LINK_COPIED": "메시지 URL이 클립보드에 복사되었습니다",
      "DELETE_CONFIRMATION": {
        "TITLE": "이 메시지를 삭제하시겠습니까?",
        "MESSAGE": "이 작업은 취소할 수 없습니다",
        "DELETE": "삭제",
        "CANCEL": "취소"
      },
      "REPORT_MESSAGE": {
        "LABEL": "Report message",
        "TITLE": "Report Captain message",
        "DESCRIPTION": "Found an issue with this AI response? Let us know what went wrong and our team will review it to help improve Captain's accuracy.",
        "PROBLEM_TYPE": "Problem type",
        "PROBLEM_TYPE_PLACEHOLDER": "Select a problem type",
        "DESCRIPTION_LABEL": "설명",
        "DESCRIPTION_PLACEHOLDER": "Describe the problem in detail",
        "SUBMIT": "Report",
        "SUCCESS": "Thanks for reporting. Our team will take a look.",
        "ERROR": "Could not report this message. Please try again.",
        "REASONS": {
          "incorrect_information": "Incorrect information",
          "inappropriate_response": "Inappropriate response",
          "incomplete_response": "Incomplete response",
          "outdated_information": "Outdated information",
          "other": "Other"
        }
      }
    },
    "SIDEBAR": {
      "CONTACT": "연락처",
      "COPILOT": "Copilot"
    },
    "VOICE_WIDGET": {
      "INCOMING_CALL": "수신 전화",
      "OUTGOING_CALL": "발신 전화",
      "CALL_IN_PROGRESS": "통화 중",
      "NOT_ANSWERED_YET": "아직 응답하지 않았습니다",
      "HANDLED_IN_ANOTHER_TAB": "다른 탭에서 처리 중입니다",
      "REJECT_CALL": "거부",
      "DISMISS_CALL": "닫기",
      "JOIN_CALL": "통화 참가",
      "END_CALL": "통화 종료",
      "MUTE": "Mute mic",
      "UNMUTE": "Unmute mic",
      "VIEW_CHAT_HISTORY": "View chat history",
      "GO_TO_CONVERSATION": "Go to conversation thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "대화 내용 보내기",
    "DESC": "지정된 이메일 주소로 대화 내용 사본을 보냅니다",
    "SUBMIT": "제출",
    "CANCEL": "취소",
    "SEND_EMAIL_SUCCESS": "대화 내용이 성공적으로 전송되었습니다",
    "SEND_EMAIL_ERROR": "오류가 발생했습니다. 다시 시도해 주십시오.",
    "SEND_EMAIL_PAYMENT_REQUIRED": "현재 플랜에서는 이메일 대화 기록을 사용할 수 없습니다. 이 기능을 사용하려면 업그레이드하십시오.",
    "FORM": {
      "SEND_TO_CONTACT": "고객에게 대화 기록 보내기",
      "SEND_TO_AGENT": "배정된 에이전트에게 대화 기록 보내기",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "다른 이메일 주소로 대화 기록 보내기",
      "EMAIL": {
        "PLACEHOLDER": "이메일 주소를 입력하십시오",
        "ERROR": "올바른 이메일 주소를 입력하십시오"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "안녕하세요 👋, {installationName}에 오신 것을 환영합니다!",
    "DESCRIPTION": "가입해 주셔서 감사합니다. {installationName}을(를) 최대한 활용하실 수 있도록 도와드리겠습니다. {installationName}에서 경험을 향상시키기 위해 할 수 있는 몇 가지를 소개합니다.",
    "GREETING_MORNING": "👋 좋은 아침입니다, {name}님. {installationName}에 오신 것을 환영합니다.",
    "GREETING_AFTERNOON": "👋 좋은 오후입니다, {name}님. {installationName}에 오신 것을 환영합니다.",
    "GREETING_EVENING": "👋 좋은 저녁입니다, {name}님. {installationName}에 오신 것을 환영합니다.",
    "READ_LATEST_UPDATES": "최근 업데이트 내용 보기",
    "ALL_CONVERSATION": {
      "TITLE": "모든 대화를 한 곳에서",
      "DESCRIPTION": "고객들과의 모든 대화를 하나의 대시보드에서 확인하십시오. 대화를 채널별, 라벨별, 상태별로 필터링할 수 있습니다.",
      "NEW_LINK": "클릭하여 받은 메시지함을 생성하십시오"
    },
    "TEAM_MEMBERS": {
      "TITLE": "팀 구성원을 초대하십시오",
      "DESCRIPTION": "고객과 대화할 준비가 되셨다면, 팀원들을 초대하여 도움을 받으십시오. 에이전트 목록에 팀원의 이메일 주소를 추가하여 초대할 수 있습니다.",
      "NEW_LINK": "클릭하여 팀원을 초대하십시오"
    },
    "LABELS": {
      "TITLE": "대화를 라벨로 정리하기",
      "DESCRIPTION": "라벨은 대화를 분류할 수 있는 쉬운 방법을 제공합니다. 예를 들어 #support-enquiry, #billing-question 등과 같은 라벨을 생성하여 나중에 대화에서 사용할 수 있습니다.",
      "NEW_LINK": "클릭하여 태그를 생성하십시오"
    },
    "CANNED_RESPONSES": {
      "TITLE": "미리 준비된 답변 생성",
      "DESCRIPTION": "미리 작성된 빠른 답변 템플릿을 통해 대화에 신속하게 응답할 수 있습니다. 에이전트가 '/' 문자와 단축 코드를 입력하여 답변을 삽입할 수 있습니다.",
      "NEW_LINK": "클릭하여 미리 준비된 답변을 생성하십시오"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "배정된 에이전트",
    "SELF_ASSIGN": "나에게 배정",
    "TEAM_LABEL": "배정된 팀",
    "SELECT": {
      "PLACEHOLDER": "없음"
    },
    "ACCORDION": {
      "CONTACT_DETAILS": "연락처 세부 정보",
      "CONVERSATION_ACTIONS": "대화 작업",
      "CONVERSATION_LABELS": "대화 라벨",
      "CONVERSATION_INFO": "대화 정보",
      "CONTACT_NOTES": "연락처 메모",
      "CONTACT_ATTRIBUTES": "연락처 속성",
      "PREVIOUS_CONVERSATION": "이전 대화",
      "MACROS": "매크로",
      "LINEAR_ISSUES": "연결된 Linear 이슈",
      "SHOPIFY_ORDERS": "Shopify 주문",
      "SHARED_FILES": "Attachments"
    },
    "SHARED_FILES": {
      "EMPTY": "No attachments yet",
      "DOWNLOAD": "Download file",
      "DOWNLOAD_ERROR": "Could not download the file. Please try again.",
      "MEDIA_HEADING": "미디어",
      "FILES_HEADING": "Files",
      "VIEW_ALL": "모두 보기",
      "SHOW_LESS": "Show less",
      "MORE_COUNT": "+{count}",
      "UNTITLED_FILE": "Untitled file",
      "JUMP_TO_MESSAGE": "Jump to message"
    },
    "SHOPIFY": {
      "ORDER_ID": "주문 #{id}",
      "ERROR": "주문 불러오기 오류",
      "NO_SHOPIFY_ORDERS": "주문을 찾을 수 없습니다",
      "FINANCIAL_STATUS": {
        "PENDING": "대기 중",
        "AUTHORIZED": "승인됨",
        "PARTIALLY_PAID": "일부 결제됨",
        "PAID": "결제 완료",
        "PARTIALLY_REFUNDED": "일부 환불됨",
        "REFUNDED": "환불됨",
        "VOIDED": "무효화됨"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "이행 완료",
        "PARTIALLY_FULFILLED": "일부 이행됨",
        "UNFULFILLED": "미이행"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "속성 생성",
    "NO_RECORDS_FOUND": "속성을 찾을 수 없습니다",
    "UPDATE": {
      "SUCCESS": "속성이 성공적으로 업데이트되었습니다",
      "ERROR": "속성을 업데이트할 수 없습니다. 나중에 다시 시도해 주십시오."
    },
    "ADD": {
      "TITLE": "추가",
      "SUCCESS": "속성이 성공적으로 추가되었습니다",
      "ERROR": "속성을 추가할 수 없습니다. 나중에 다시 시도해 주십시오."
    },
    "DELETE": {
      "SUCCESS": "속성이 성공적으로 삭제되었습니다",
      "ERROR": "속성을 삭제할 수 없습니다. 나중에 다시 시도해 주십시오."
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "속성 추가",
      "PLACEHOLDER": "속성 검색",
      "NO_RESULT": "속성을 찾을 수 없습니다"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "보낸 사람",
    "TO": "받는 사람",
    "BCC": "숨은 참조",
    "CC": "참조",
    "SUBJECT": "제목",
    "EXPAND": "이메일 펼치기"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "참여 중",
    "SIDEBAR_TITLE": "대화 참여자",
    "NO_RECORDS_FOUND": "검색 결과가 없습니다",
    "ADD_PARTICIPANTS": "참여자 선택",
    "REMANING_PARTICIPANTS_TEXT": "+{count}명",
    "REMANING_PARTICIPANT_TEXT": "+{count}명",
    "TOTAL_PARTICIPANTS_TEXT": "{count}명이 참여하고 있습니다.",
    "TOTAL_PARTICIPANT_TEXT": "{count}명이 참여하고 있습니다.",
    "NO_PARTICIPANTS_TEXT": "참여 중인 사람이 없습니다.",
    "WATCH_CONVERSATION": "대화 참여",
    "YOU_ARE_WATCHING": "참여 중입니다",
    "API": {
      "ERROR_MESSAGE": "업데이트할 수 없습니다. 다시 시도해 주십시오!",
      "SUCCESS_MESSAGE": "참여자가 업데이트되었습니다!"
    }
  },
  "TRANSLATE_MODAL": {
    "TITLE": "번역된 내용 보기",
    "DESC": "각 언어별로 번역된 내용을 확인할 수 있습니다.",
    "ORIGINAL_CONTENT": "원본 내용",
    "TRANSLATED_CONTENT": "번역된 내용",
    "NO_TRANSLATIONS_AVAILABLE": "이 내용에 대한 번역이 없습니다"
  },
  "TYPING": {
    "ONE": "{user}님이 입력하고 있습니다",
    "TWO": "{user}님과 {secondUser}님이 입력하고 있습니다",
    "MULTIPLE": "{user}님 외 {count}명이 입력하고 있습니다"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "다음 프롬프트를 시도해 보십시오"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "첨부 파일을 다운로드할 수 없습니다. 다시 시도해 주십시오."
  }
}
